/**
 * Модель для работы с зонами
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import {IId, ISelect, IArea, ICoordXY, ICoordXYZW, IUser, IEvent, IAreasAppliance} from './types';
import MapsService, { IUpdateAreaBody } from '../services/MapsService';
import ProtectionsService from '../services/ProtectionsService';
import UsersService, { IGetAllParams as IGetUserAllParams } from '../services/UsersService';
import NotificationsService from '../services/NotificationsService';

export interface IData {
  dangers: ISelect[];
  protections: ISelect[];
  users: IUser[] | null;
  areas: IArea[];
  areasAppliance: IAreasAppliance[];
}

interface IState {
  data: IData;
  item: IArea | null;
  hover: IArea | null;
  // Зона из критического уведомления — устойчивая подсветка до смены плана
  alert: IArea | null;
  notifications: IEvent[];
  coordinates: ICoordXYZW | null;
}

const initialState: IState = {
  data: {
    dangers: [],
    protections: [],
    users: null,
    areas: [],
    areasAppliance: []

  },
  item: null,
  hover: null,
  alert: null,
  notifications: [],
  coordinates: null
};

export const infrastructureAreas = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IData): IState {
      return {
        ...state,
        data: {
          ...state.data,
          ...payload
        }
      };
    },
    setArea(state: IState, payload: IArea): IState {
      return { ...state, item: payload };
    },
    setHover(state: IState, payload: IArea | null): IState {
      return { ...state, hover: payload };
    },
    resetHover(state: IState): IState {
      const { hover } = initialState;

      return { ...state, hover };
    },
    setAlertArea(state: IState, payload: IArea): IState {
      return { ...state, alert: payload };
    },
    resetAlertArea(state: IState): IState {
      const { alert } = initialState;

      return { ...state, alert };
    },
    setNotifications(state: IState, payload: IEvent[]): IState {
      return { ...state, notifications: payload };
    },
    setCoordinates(state: IState, payload: ICoordXYZW): IState {
      return { ...state, coordinates: payload };
    },
    resetCoordinates(state: IState): IState {
      const { coordinates } = initialState;

      return { ...state, coordinates };
    }
  },
  effects: (dispatch: any) => ({
    async getData() {
      const [
        { data: dangers },
        {
          data: { data: protections }
        },
        { data: areas },
        { data: areasAppliance }
      ] = await Promise.all([
        MapsService.getDangers(),
        ProtectionsService.getTypeAll({ pageSize: 100 }),
        MapsService.getAreasByQuery(),
        MapsService.getAreaAppliance()
      ]);

      this.setData({ dangers, protections, areas, areasAppliance });
    },
    async getDataUsers(params: IGetUserAllParams) {
      const {
        data: { employees: users }
        // ХАК - убрать когда появится универсальный метод получения максимального кол-ва записей
      } = await UsersService.getAllEmployees({ ...params, pageSize: 1000 });

      this.setData({ users });
    },
    async resetDataUsers() {
      const {
        data: { users }
      } = initialState;

      this.setData({ users });
    },
    async getArea(id: IId) {
      const { data } = await MapsService.getArea(id);

      this.setArea(data);
    },
    async resetArea() {
      const { item } = initialState;

      this.setArea(item);
    },
    async updateOrCreateArea(body: any) {
      try {
        await MapsService.updateOrCreateArea(body);

        dispatch.infrastructureMap.getMap();
      } catch (error) {
        return error;
      }
    },
    async deleteArea(id: any) {
      try {
        await MapsService.deleteArea(id);

        dispatch.infrastructureMap.getMap();
      } catch (error) {
        return error;
      }
    },
    focusArea(center: ICoordXY) {
      // const payload = { zoom: 20, center };
      const payload = { center };

      dispatch.infrastructureMap.setFocus(payload);
    },
    async getNotifications(areaId: IId) {
      const {
        data: { data }
      } = await NotificationsService.getFullAll({ areaId });

      this.setNotifications(data);
    }
  })
});
